<template>
   <div>
    <b-modal id="add-ons" ref="add-ons" size="lg" hide-footer :title="$t('message.ADD_ONS')" :no-close-on-backdrop="true">
        <div class="row">
            <div class="col-md-6 form-group">
                <label class="label">{{ $t('message.NAME')}}</label>
                <input type="name" name="name" v-model="name" class="form-control" v-validate="'required'" :class="{'is-invalid':errors.has('name')}">
                <span v-show="errors.has('name')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
            </div>
            <div class="col-md-6 form-group">
                <label class="label">{{ $t('message.PRICE')}}</label>
                <input type="number" name="price" v-model="price" class="form-control" v-validate="'required'" :class="{'is-invalid':errors.has('price')}">
                <span v-show="errors.has('price')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
            </div>
            <div class="col-md-6 form-group">
                <label class="label">Type</label> {{$t('message.TYPE_CAR')}}
                <v-select :options="filter_type" name="type" v-model="type" class="as-input-ht" v-validate="'required'" :class="{'is-invalid':errors.has('type')}"></v-select>
                <span v-show="errors.has('type')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
            </div>
        </div>
       <br />
       <hr>
        <span class="float-right">
        <b-button class="btn btn-info mr-2" v-on:click="add_on">{{ $t('message.NEXT')}}</b-button>
        <b-button class=" btn btn-danger" @click="$bvModal.hide('add-ons')">{{ $t('message.CLOSE')}}</b-button>
        </span>

    </b-modal>
   </div>
</template>
<script>
export default {
    data () {
      return {
            type : '',
            name: '',
            price: ''
      }
    },

    computed:{
        filter_type(){
            return [
                 {label:this.$t('message.TYPE_CAR'),code:1},
                 {label:this.$t('message.TYPE_WORK'),code:2} 
            ]
        }
    },
    

    methods:{
        async add_on() {
            const valid = await this.$validator.validateAll()
            if(valid) {
                let form_data = {
                    name : this.name,
                    price : this.price,
                    type : this.type.code
                }

                let loader = this.$loading.show()

                try {
                    await this.$store.dispatch('admin_add_on/create_add_on', form_data)
                    this.$store.dispatch('notifications_alert/success', this.$t('message.MSG_ADDED_SUCC'))
                    this.$refs['add-ons'].hide()
                    loader.hide()
                } catch (e) {
                    this.$store.dispatch('notifications_alert/error', this.$t('message.SOMETHING_WENT_WRONG'))
                    loader.hide()
                }
            }
        },

        show()
        {   
            this.name = '',
            this.price = '',
            this.type = '',
            
            this.$refs['add-ons'].show()
        }
    }
}
</script>
<style >
.modal.show .modal-dialog{
    margin-top: -101px;
}
</style>